import {openDialog} from 'platform/components';

import i18n from '@dms/i18n';

import {RateMatrixCellData} from '../types/RateMatrixCellData';
import {RateMatrixBulkRatesForm} from './RateMatrixBulkRatesForm';

interface OpenRateMatrixBulkRatesDialogOptions {
  selectedCount: number;
  onSubmit: (data: RateMatrixCellData) => void;
  onRemove: VoidFunction;
  testId: string;
}

export function openRateMatrixBulkRatesDialog(options: OpenRateMatrixBulkRatesDialogOptions) {
  openDialog(
    <RateMatrixBulkRatesForm
      selectedCount={options.selectedCount}
      onSubmit={options.onSubmit}
      onRemove={options.onRemove}
      data-testid={options.testId}
    />,
    {
      id: 'rate-matrix-bulk-rates-dialog',
      title: i18n.t('page.vehicle.financingAndLeasing.bulkEditRates'),
      size: 'small',
    }
  );
}
